"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

var PropertyTextInput = function PropertyTextInput(_ref) {
  var question = _ref.question,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;
  var TextInput = question.propertyFieldType === 'textarea' ? _UITextArea.default : _UITextInput.default;
  var extraInputProps = question.propertyFieldType === 'textarea' ? {
    resize: disabled ? false : 'vertical'
  } : {};
  return _react.default.createElement(TextInput, Object.assign({
    value: question.getValue() || '',
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.propertyPlaceholders.textInput')
  }, extraInputProps));
};

PropertyTextInput.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired
};
var _default = PropertyTextInput;
exports.default = _default;
module.exports = exports.default;